'use strict';
angular.module('schoolLinqApp').factory('accountService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/account';

		// EndpointEnum: ReadAccountById
		function getAccount(id) {
			return $http.get(endpoint + '/' + id);
		}

		function searchAccount(
			accountTypeIds,
			description,
			accountNumber,
			limit,
			filter,
			bankId,
			prcCode,
			onlyActive,
			searchMode,
			onlyPayroll,
			onlyNutrition
		) {
			return $http.get(endpoint + '/search', {
				params: {
					accountTypeIds: accountTypeIds,
					description: description,
					accountNumber: accountNumber,
					limit: limit,
					filter: filter,
					bankId: bankId,
					prcCode: prcCode,
					onlyActive: onlyActive,
					searchMode: searchMode,
					onlyPayroll: onlyPayroll,
					onlyNutrition: onlyNutrition,
				},
			});
		}

		function searchFundAccount(accountTypeIds, description, accountNumber, limit, filter, bankId) {
			return $http.get(endpoint + '/search', {
				params: {
					accountTypeIds: accountTypeIds,
					description: description,
					accountNumber: accountNumber,
					limit: limit,
					filter: filter,
					bankId: bankId,
					excludePayroll: true,
				},
			});
		}

		function searchPayrollAccount(accountTypeIds, description, accountNumber, limit, filter, bankId) {
			return $http.get(endpoint + '/search', {
				params: {
					accountTypeIds: accountTypeIds,
					description: description,
					accountNumber: accountNumber,
					limit: limit,
					filter: filter,
					bankId: bankId,
					onlyPayroll: true,
				},
			});
		}

		function searchCashAccount(accountId, accountNumber, limit) {
			return $http.get(endpoint + '/searchCash', {
				params: {
					accountId: accountId,
					accountNumber: accountNumber,
					limit: limit,
				},
			});
		}

		function searchOffsetsForAccount(accountId, accountTypeId, accountNumber, limit) {
			return $http.get(endpoint + '/searchOffsetsForAccount', {
				params: {
					accountId: accountId,
					accountTypeId: accountTypeId,
					accountNumber: accountNumber,
					limit: limit,
				},
			});
		}

		function getAccounts() {
			return $http.get(endpoint + '/list');
		}

		function getNumberOfAccounts(accountPaging) {
			return $http.post(endpoint + '/numberOf', accountPaging);
		}

		function getAccountsByPage(accountPaging) {
			return $http.post(endpoint + '/getByPage', accountPaging);
		}

		function getPageIndexForAccount(accountPaging) {
			return $http.post(endpoint + '/getPageIndexForAccount', accountPaging);
		}

		// EndpointEnum: CreateAccount
		function addAccount(account) {
			return $http.put(endpoint, account);
		}

		// EndpointEnum: UpdateAccount
		function postAccount(account) {
			return $http.post(endpoint, account);
		}

		// EndpointEnum: DeleteAccount
		function deleteAccount(id) {
			return $http.delete(endpoint + '/' + id);
		}

		function getAllAccountBudgets(accountPaging, fiscalYear) {
			return $http.post(endpoint + '/get-all-account-budgets', accountPaging, {
				params: { fiscalYear: fiscalYear, useHangfire: false },
			});
		}

		function getAccountRemainingBudget(poId, accountId, date) {
			return $http.get(endpoint + '/getAccountRemainingBudget', {
				params: { poId: poId, accountId: accountId, date: date },
			});
		}

		function getAccountBalancesForFiscalYear(id, fiscalYear) {
			return $http.get(endpoint + '/accountBalances', {
				params: { id: id, fiscalYear: fiscalYear },
			});
		}

		function getAccountBeginningBalanceForFiscalYear(id, fiscalYear) {
			return $http.get(endpoint + '/accountBeginningBalance', {
				params: { id: id, fiscalYear: fiscalYear },
			});
		}

		function getFunds(accountTypeIds) {
			return $http.get(endpoint + '/fundList', {
				params: { accountTypeIds: accountTypeIds },
			});
		}

		function getElementsMinMax(elementNames) {
			return $http.get(endpoint + '/getElementMinMaxList', {
				params: { elementNames: elementNames },
			});
		}

		function applyMask(mask, accountNumber) {
			if (
				mask === undefined ||
				mask === null ||
				mask.length === 0 ||
				accountNumber === undefined ||
				accountNumber === null ||
				accountNumber.length === 0
			) {
				return '';
			}

			if (mask.length !== accountNumber.length) {
				return '';
			}

			var appliedMask = '';

			for (var charIndex = 0; charIndex < mask.length; charIndex++) {
				var currentMaskChar = mask[charIndex];
				var currentAccountChar = accountNumber[charIndex];

				if ((currentMaskChar === '.' && currentAccountChar !== '.') || (currentMaskChar !== '.' && currentAccountChar === '.')) {
					return '';
				}

				if (currentMaskChar === '?') {
					appliedMask = appliedMask + currentAccountChar;
				} else {
					appliedMask = appliedMask + currentMaskChar;
				}
			}

			return appliedMask;
		}

		function getEmployeeCheckJob(accountId, model) {
			return $http.get(endpoint + '/getEmployeeCheckJob', {
				params: { accountId: accountId, FromDate: model.from, ToDate: model.to, FiscalYear: model.fiscalYear },
			});
		}

		function verifyAccount(accountNumber) {
			return $http.get(endpoint + '/verifyAccount', {
				params: { accountNumber: accountNumber },
			});
		}

		return {
			getAccount: getAccount,
			getAccounts: getAccounts,
			getNumberOfAccounts: getNumberOfAccounts,
			getAccountsByPage: getAccountsByPage,
			getPageIndexForAccount: getPageIndexForAccount,
			addAccount: addAccount,
			postAccount: postAccount,
			searchAccount: searchAccount,
			searchFundAccount: searchFundAccount,
			searchPayrollAccount: searchPayrollAccount,
			searchCashAccount: searchCashAccount,
			searchOffsetsForAccount: searchOffsetsForAccount,
			deleteAccount: deleteAccount,
			getAllAccountBudgets: getAllAccountBudgets,
			getAccountRemainingBudget: getAccountRemainingBudget,
			getAccountBalancesForFiscalYear: getAccountBalancesForFiscalYear,
			getAccountBeginningBalanceForFiscalYear: getAccountBeginningBalanceForFiscalYear,
			getFunds: getFunds,
			getElementsMinMax: getElementsMinMax,
			applyMask: applyMask,
			verifyAccount: verifyAccount,
			getEmployeeCheckJob: getEmployeeCheckJob,
		};
	},
]);
